import styled from 'styled-components';
import { motion } from 'framer-motion';
import { colors } from '../../utils/colors';

const SocialList = styled.ul.withConfig({
  shouldForwardProp: (prop) => !['margin', 'center'].includes(prop)
})`
  list-style: none;
  padding: 0;
  margin: ${props => props.margin || '0'};
  display: flex;
  gap: 1rem;
  justify-content: ${props => props.center ? 'center' : 'flex-start'};
`;

const SocialLink = styled(motion.a).withConfig({
  shouldForwardProp: (prop) => !['size', 'fontSize'].includes(prop)
})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.size || '40px'};
  height: ${props => props.size || '40px'};
  border-radius: 50%;
  background: ${colors.primary};
  color: white;
  text-decoration: none;
  transition: background-color 0.3s ease;

  i {
    font-size: ${props => props.fontSize || '1.2rem'};
  }

  &:hover {
    background: ${colors.primaryDark};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px ${colors.primaryLight};
  }
`;

const socialNetworks = [
  {
    name: 'Instagram',
    icon: 'fa-brands fa-instagram',
    url: 'https://instagram.com/psicologaandreadavila',
    label: 'Sígueme en Instagram'
  },
  {
    name: 'LinkedIn',
    icon: 'fa-brands fa-linkedin-in',
    url: 'https://linkedin.com/in/andrea-davila',
    label: 'Conéctate conmigo en LinkedIn'
  },
  {
    name: 'WhatsApp',
    icon: 'fa-brands fa-whatsapp',
    url: 'https://wa.me/59891288376',
    label: 'Contáctame por WhatsApp'
  }
];

export const SocialNetworks = ({ margin, size, fontSize, center = false }) => {
  return (
    <SocialList margin={margin} center={center} role="list">
      {socialNetworks.map(network => (
        <li key={network.name}>
          <SocialLink
            href={network.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={network.label}
            size={size}
            fontSize={fontSize}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            <i className={network.icon} aria-hidden="true" />
          </SocialLink>
        </li>
      ))}
    </SocialList>
  );
};
